const RUSSIAN_COUNTRY_CODE = '7';
const RUSSIAN_PREFIX = '+7';
const RUSSIAN_NUMBER_STARTS = ['7'] as const;

const FORMAT_POSITIONS = {
  COUNTRY_CODE_END: 1,
  AREA_CODE_START: 1,
  AREA_CODE_END: 4,
  MOBILE_OPERATOR_CODE_LENGTH: 3,
  FIRST_PART_START: 4,
  FIRST_PART_END: 7,
  SECOND_PART_START: 7,
  SECOND_PART_END: 9,
  THIRD_PART_START: 9,
  THIRD_PART_END: 11,
} as const;

export const formatPhoneNumber = (value: string): string => {
  if (!value) return value;

  const digitsOnly = value.replace(/\D/g, '');
  const digitsLength = digitsOnly.length;

  if (digitsLength === 0) return '';

  const firstDigit = digitsOnly[0];
  const isRussianNumber = RUSSIAN_NUMBER_STARTS.includes(
    firstDigit as (typeof RUSSIAN_NUMBER_STARTS)[number],
  );

  if (!isRussianNumber) {
    return `+ ${digitsOnly}`;
  }

  // Специальная обработка: если введен только "7" и это 4-й символ (например, "+7 "), очищаем
  if (digitsOnly === RUSSIAN_COUNTRY_CODE && value.length === 4) {
    return '';
  }

  // Форматирование российского номера: +7 (XXX) XXX XX-XX
  let formatted = RUSSIAN_PREFIX;

  // Если номер начинается с 9, обрабатываем его как мобильный (9XX)
  if (firstDigit === '9') {
    // Код оператора (первые 3 цифры: 9XX)
    const areaCode = digitsOnly.slice(
      0,
      FORMAT_POSITIONS.MOBILE_OPERATOR_CODE_LENGTH,
    );
    formatted += ` (${areaCode}`;

    // Закрываем скобку и добавляем первую часть номера
    if (digitsLength > FORMAT_POSITIONS.MOBILE_OPERATOR_CODE_LENGTH) {
      formatted += `) ${digitsOnly.slice(
        FORMAT_POSITIONS.MOBILE_OPERATOR_CODE_LENGTH,
        FORMAT_POSITIONS.FIRST_PART_END,
      )}`;
    }
  } else {
    // Для номеров, начинающихся с 7 или 8
    formatted += ' ';

    // Код оператора (XXX)
    if (digitsLength > FORMAT_POSITIONS.COUNTRY_CODE_END) {
      formatted += `(${digitsOnly.slice(
        FORMAT_POSITIONS.AREA_CODE_START,
        FORMAT_POSITIONS.AREA_CODE_END,
      )}`;
    }

    // Первая часть номера (XXX)
    if (digitsLength > FORMAT_POSITIONS.AREA_CODE_END) {
      formatted += `) ${digitsOnly.slice(
        FORMAT_POSITIONS.FIRST_PART_START,
        FORMAT_POSITIONS.FIRST_PART_END,
      )}`;
    }
  }

  // Вторая часть номера (XX)
  if (digitsLength > FORMAT_POSITIONS.FIRST_PART_END) {
    const secondPart = digitsOnly.slice(
      FORMAT_POSITIONS.SECOND_PART_START,
      FORMAT_POSITIONS.SECOND_PART_END,
    );
    formatted += ` ${secondPart}`;
  }

  // Третья часть номера (-XX)
  if (digitsLength > FORMAT_POSITIONS.SECOND_PART_END) {
    const thirdPart = digitsOnly.slice(
      FORMAT_POSITIONS.THIRD_PART_START,
      FORMAT_POSITIONS.THIRD_PART_END,
    );
    formatted += `-${thirdPart}`;
  }

  return formatted;
};
